export default __webpack_public_path__ + "static/media/closeBlue.3bb3fc3e.svg";